export const IDENTITIES_LIST = {
  TITLE: 'Access Review',
  SEARCH_PLACEHOLDER: 'Search by account or owner',
  SOURCE_PLACEHOLDER: 'Select Identity Source',
  NAME: 'Name',
  ACCOUNT_NAME: 'Account Name',
  OWNER: 'Owner',
  EMAIL: 'Email',
  MFA: 'MFA',
  SOURCE: 'Source',
  LAST_LOGIN: 'Last Login',
  STATUS: 'Status',
  ROLE: 'Role',
  ROLES: 'Roles',
  TWO_FA: '2FA',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  REMOVED: 'Removed',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  LOADING: 'Loading identities...',
  NO_IDENTITIES: 'No identities found',
}
